import { forwardRef } from "react";
import type { BadgeProps, BadgeStatus } from "./types";

const statusColors: Record<BadgeStatus, { bg: string; text: string }> = {
  active: { bg: "rgba(34,197,94,0.15)", text: "#22c55e" },
  completed: { bg: "rgba(59,130,246,0.15)", text: "#3b82f6" },
  overdue: { bg: "rgba(239,68,68,0.15)", text: "#ef4444" },
  draft: { bg: "rgba(161,161,166,0.15)", text: "#a1a1a6" },
};

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  {
    variant = "category",
    status,
    color,
    className = "",
    children,
    style,
    ...rest
  },
  ref,
) {
  const base =
    "inline-block rounded-full px-2.5 py-0.5 text-[11px] font-medium";

  let colorStyle: React.CSSProperties = {};

  if (variant === "status" && status) {
    const s = statusColors[status];
    colorStyle = { backgroundColor: s.bg, color: s.text };
  } else if (color) {
    colorStyle = { backgroundColor: color.bg, color: color.text };
  } else {
    colorStyle = {
      backgroundColor: "var(--color-accent-soft)",
      color: "var(--color-accent)",
    };
  }

  return (
    <span
      ref={ref}
      className={`${base} ${className}`}
      style={{ ...colorStyle, ...style }}
      {...rest}
    >
      {children}
    </span>
  );
});
